<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title40"><h1 class="title-toc">Table of Contents</h1>
</a><div class="toc_entry"><a id="title40"><br/>
</a><span class="toc_entry_titlePage" href="#/e9781783408566_tp01" title="Link target outside of Sample">Title Page</span><br/>
<span class="toc_entry_alsoby" href="#/e9781783408566_als01" title="Link target outside of Sample"><strong class="b">By the same author:</strong></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781783408566_cop01" title="Link target outside of Sample">Copyright Page</span><br/>
<a class="toc_entry_dedicationPage" href="#/e9781783408566_ded01">Dedication</a><br/>
<a class="toc_entry_acknowPage" href="#/e9781783408566_ack01"><strong class="b">Acknowledgements</strong></a><br/>
<a class="toc_entry_frontMatter" href="#/e9781783408566_fm02"><strong class="b">Leslie Robinson &amp; Stanley Sheead</strong></a><br/>
<a class="toc_entry_frontMatter" href="#/e9781783408566_fm03"><strong class="b">Biltcliffe – Photographers</strong></a><br/>
<a class="toc_entry_part" href="#/e9781783408566_p01"><strong class="b">The Townships</strong></a><br/>
<div class="toc_entry"><span class="toc_entry_chapter" href="#/e9781783408566_c01" title="Link target outside of Sample"><strong class="b">Skelmanthorpe</strong></span><br/>
<span class="toc_entry_chapter" href="#/e9781783408566_c02" title="Link target outside of Sample"><strong class="b">Clayton West</strong></span><br/>
<span class="toc_entry_chapter" href="#/e9781783408566_c03" title="Link target outside of Sample"><strong class="b">High Hoyland</strong></span><br/></div></div>
<div class="toc_entry"><span class="toc_entry_backMatter" href="#/e9781783408566_bm01" title="Link target outside of Sample"><strong class="b">Supplementary Chronology</strong></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783408566_toc01.vue?311c4394